














import { computed, defineComponent, PropType } from '~/utils/nuxt3-migration'
import { SaleRequestStatus } from '~/models/sale-requests'
import { ciPending } from '~/icons/source/regular/pending'
import { ciApproved } from '~/icons/source/regular/approved'
import { defineComponentTranslations } from '~/utils/i18n'
import { useI18n } from '~/compositions/i18n'
import { ciDenied } from '~/icons/source/regular/denied'
import { ciSubtract } from '~/icons/source/regular/subtract'
import { ciClock } from '~/icons/source/regular/clock'

export default defineComponent({
  props: {
    status: {
      type: String as PropType<SaleRequestStatus>,
      required: true
    },
    userIsBuyer: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { t } = useI18n()

    const icon = computed(() => {
      switch (props.status) {
        case 'pending':
          return ciClock
        case 'completed': {
          return ciApproved
        }
        case 'rejected': {
          return ciDenied
        }
        case 'expired': {
          return ciPending
        }
        case 'cancelled': {
          return ciSubtract
        }
      }
    })

    const bgClass = computed(() => {
      switch (props.status) {
        case 'pending':
          return 'tw-bg-cyan-300'
        case 'completed': {
          return 'tw-bg-green-300'
        }
        case 'rejected': {
          return 'tw-bg-red-400'
        }
        case 'expired': {
          return 'tw-bg-amber-800'
        }
        case 'cancelled': {
          return 'tw-bg-grey-600'
        }
      }
    })

    const statusText = computed(() => {
      switch (props.status) {
        case 'pending':
          return t('sale_request_status_pending')
        case 'completed': {
          return props.userIsBuyer
            ? t('sale_request_status_completed_buyer')
            : t('sale_request_status_completed_seller')
        }
        case 'rejected': {
          return t('sale_request_status_rejected')
        }
        case 'expired': {
          return t('sale_request_status_expired')
        }
        case 'cancelled': {
          return t('sale_request_status_cancelled')
        }
      }
    })

    return {
      icon,
      bgClass,
      statusText
    }
  },
  i18n: defineComponentTranslations({
    sale_request_status_pending: {
      en: 'Pending',
      el: 'Εκκρεμεί'
    },
    sale_request_status_completed_seller: {
      en: 'Completed',
      el: 'Ολοκληρώθηκε'
    },
    sale_request_status_completed_buyer: {
      en: 'Bought it',
      el: 'Το αγόρασα'
    },
    sale_request_status_rejected: {
      en: 'Rejected',
      el: 'Απορρίφθηκε'
    },
    sale_request_status_expired: {
      en: 'Expired',
      el: 'Έληξε'
    },
    sale_request_status_cancelled: {
      en: 'Cancelled',
      el: 'Ακυρώθηκε'
    }
  })
})
